import React from "react";
import { useNavigate } from "react-router-dom";
import { extractDate } from "../../../Components/Functions/date.fun";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

const tableHead = ["Sr.", "Name / id", "assignTo / date", "status", "Actions"];
const getBadge = (status) => {
  switch (status) {
    case "available":
      return <span className="badge bg-green text-green-fg">Available</span>;
    case "pending":
      return (
        <span className="badge bg-yellow text-yellow-fg">Pending Approval</span>
      );
    case "assigned":
      return <span className="badge bg-blue text-blue-fg">Assigned</span>;
    default:
      return <span className="badge bg-gray text-gray-fg">{status}</span>;
  }
};
const AssetsTable = ({ data, currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/company-assets/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>
                  {item?.name}
                  <br />
                  Id: {item?.assetId}
                </td>
                <td>
                  {item?.assignTo ? (
                    <>
                      {item?.assignToName}
                      <br />
                      {item.assignDate}
                    </>
                  ) : (
                    "Not Assigned"
                  )}
                </td>
                <td>{getBadge(item?.status)}</td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AssetsTable;
